import BaseRepository, { PagedListResponse } from './base-repository';

import { LookupEntity, LookupEntity$Type } from '@/types/LookupEntity';

export type Lookup$Query = {
  q: string;
  count: number;
  offset: number;
};

if (process.env.VUE_APP_MOCK_API === 'yes') {
  (function _bootstrap() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const adapert = require('../mocks/index').default;
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const fnc = require('../mocks/lookup').default;
    fnc(adapert);
  })();
}

export default class LookupRepository<E extends Entity = LookupEntity> extends BaseRepository<
  E,
  Lookup$Query,
  PagedListResponse<E>
> {
  constructor(type: LookupEntity$Type) {
    super(`/lookup/${type}`);
  }
}
